import { useState, useCallback } from 'react';

export const useToast = () => {
  const [toastConfig, setToastConfig] = useState({
    show: false,
    message: '',
    type: 'success' // 'success', 'error', 'warning', 'info'
  });

  const showToast = useCallback((message, type = 'success', duration = 3000) => {
    setToastConfig({
      show: true,
      message,
      type
    });

    // Auto-hide after duration
    const timer = setTimeout(() => {
      hideToast();
    }, duration);

    return () => clearTimeout(timer);
  }, []);

  const hideToast = useCallback(() => {
    setToastConfig(prev => ({ ...prev, show: false }));
  }, []);

  return {
    showToast,
    hideToast,
    toastConfig
  };
};